import React, { useState } from 'react';
// @ts-ignore:next-line
import { AccordionSet, Accordion, TextLink } from '@folio/stripes/components';
import { t } from '../../../../services';
import { MainListInfoForm } from '../../../../components';
import css from './MainCreateListForm.module.css';
import { QueryBuilder } from '../QueryBuilder';
export var MainCreateListForm = function (_a) {
    var _b = _a.onValueChange, onValueChange = _b === void 0 ? function () { } : _b, listNameField = _a.listNameField, descriptionField = _a.descriptionField, visibilityField = _a.visibilityField, statusField = _a.statusField, _c = _a.selectedType, selectedType = _c === void 0 ? '' : _c, recordTypesOptions = _a.recordTypesOptions, isQueryButtonDisabled = _a.isQueryButtonDisabled;
    var _d = useState(true), isOpened = _d[0], setIsOpened = _d[1];
    var onToggleHandler = function () {
        setIsOpened(function (prevValue) { return !prevValue; });
    };
    var renderCollapseButton = function () {
        return (React.createElement(TextLink, { onClick: onToggleHandler }, isOpened ?
            (t('create-list.main.collapse-all'))
            :
                (t('create-list.main.expand-all'))));
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: css.mainFormCollapseButton }, renderCollapseButton()),
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: t('create-list.main.list-information'), open: isOpened, onToggle: onToggleHandler },
                React.createElement(MainListInfoForm, { onValueChange: onValueChange, recordTypeOptions: recordTypesOptions, listName: listNameField, description: descriptionField, visibility: visibilityField, status: statusField }))),
        React.createElement("div", { className: css.queryBuilderButton },
            React.createElement(QueryBuilder, { selectedType: selectedType, isQueryButtonDisabled: isQueryButtonDisabled, listName: listNameField, status: statusField, visibility: visibilityField, description: descriptionField }))));
};
